import styles from "./Footer.module.css";

export const Footer = () => {
  return (
    <footer className={styles.footer}>
         <p className={styles.parrafo}>&copy; 2022 AdaVision</p>
    </footer>
  );
};
